import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fc582c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "details-wrapper"
}
const _hoisted_2 = {
  key: 0,
  class: "single-column"
}
const _hoisted_3 = {
  key: 1,
  class: "double-column"
}

import { computed, watch, onMounted } from "vue"
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'

import useDetailPage from "./useDetailPage"

import ColumnLayout from "@/components/library/content/details/ColumnLayout.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'DesktopDetails',
  setup(__props) {

const store = useStore()
const route = useRoute()
const {
  content,
  isPart,
  showComments,
  showRelated,
  showSuggestions,
  showAttachments
} = useDetailPage()

const detailsLayoutTemplate =  computed(() => store.getters['detailPageLayouts/getDetailPageLayoutState'])
const noRightColumnAccess = computed(() => {
  return !showRelated.value
    && !showSuggestions.value
    && !showComments.value
    && !showAttachments.value
})

const isWidget = computed(() => store.getters['widgets/isWidget'])
const widgetScrollToWhereUsed = computed(() => store.getters['content/getWidgetScrollToWhereUsed'])

async function fetchLayoutTemplate () {
  if(!content.value.type) {
    return
  }

  await store.dispatch('detailPageLayouts/fetchDetailPageLayout',
    {type: content.value.type, id: content.value.id})
}

async function scrollToContent(): Promise<void> {
  if (route.fullPath.includes('related') && showRelated.value) {
    document.getElementById("Related")?.scrollIntoView({ block: 'center' })
  }
  if (route.fullPath.includes('attachment') && showAttachments.value) {
    document.getElementById("Attachments")?.scrollIntoView()
  }
  if (route.fullPath.includes('comments') && showComments.value) {
    document.getElementById("Comments")?.scrollIntoView()
  }
  if (route.fullPath.includes('infoWrapper')) {
    document.getElementById("InfoWrapper")?.scrollIntoView()
  }
  if (route.fullPath.includes('suggestions') && showSuggestions.value) {
    document.getElementById("Suggestions")?.scrollIntoView()
  }
  if ((route.fullPath.includes('whereused')) || (isWidget.value && widgetScrollToWhereUsed.value)) {
    document.getElementById("WhereUsed")?.scrollIntoView()
    if (isWidget.value) {
      await store.dispatch('content/setWidgetScrollToWhereUsed', false)
    }
  }
}
// using a watcher to detect when content is being evaluated as the content object is not always available on mount event
// setting a watcher on content or its properties never fires, but on a dependent computed property, it does
watch(isPart, async val => {
  if(detailsLayoutTemplate.value) return
  await fetchLayoutTemplate()
  await scrollToContent()
})
// @ts-ignore
onMounted(async () => {
  await fetchLayoutTemplate()
  await scrollToContent()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (detailsLayoutTemplate.value && !!_unref(content)?.id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (noRightColumnAccess.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(ColumnLayout, {
                  "column-info": detailsLayoutTemplate.value.leftColumn
                }, null, 8, ["column-info"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailsLayoutTemplate.value, (columnInfo, colName) => {
                  return (_openBlock(), _createBlock(ColumnLayout, {
                    key: colName,
                    "column-info": columnInfo
                  }, null, 8, ["column-info"]))
                }), 128))
              ]))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})